import { render, staticRenderFns } from "./visitOrder.vue?vue&type=template&id=21dc5fc3&scoped=true&"
import script from "./visitOrder.vue?vue&type=script&lang=js&"
export * from "./visitOrder.vue?vue&type=script&lang=js&"
import style0 from "./visitOrder.vue?vue&type=style&index=0&id=21dc5fc3&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21dc5fc3",
  null
  
)

export default component.exports